import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.25 10.0002L11.4655 13.4953C10.9288 13.7717 10.6604 13.91 10.3783 13.9643C10.1284 14.0125 9.87162 14.0125 9.62174 13.9643C9.33955 13.91 9.07121 13.7718 8.53454 13.4953L1.75 10.0002M18.25 14.0002L11.4655 17.4953C10.9288 17.7717 10.6604 17.91 10.3783 17.9643C10.1284 18.0125 9.87162 18.0125 9.62174 17.9643C9.33955 17.91 9.07121 17.7718 8.53454 17.4953L1.75 14.0002M1.75 6.00022L8.53454 2.50515C9.07121 2.22868 9.33955 2.09045 9.62174 2.0361C9.87162 1.98797 10.1284 1.98797 10.3783 2.0361C10.6604 2.09045 10.9288 2.22868 11.4655 2.50515L18.25 6.00022L11.4655 9.49528C10.9288 9.77175 10.6604 9.90999 10.3783 9.96434C10.1284 10.0125 9.87162 10.0125 9.62174 9.96434C9.33955 9.90999 9.07121 9.77175 8.53454 9.49528L1.75 6.00022Z",
		stroke: "#79716B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgLayer);
export { ForwardRef as ReactComponent };
